<template>
	<div class="phone">
		<div class="phone-screen">
			<media :source="media" height="100%" width="100%" v-if="media" />
		</div>
	</div>
</template>
<script>
	import PageComponentTemplate from '../page-component-template';
	import Media from '@/components/media';

	export default {
		name: 'page-component-phone',
		extends: PageComponentTemplate,
		components: {
			Media
		},
		computed: {
			media() {
				if (!this.options || !this.options.hasOwnProperty('media')) {
					return null;
				}

				return this.options.media;
			}
		}
	}
</script>
<style lang="less" scoped>
	@import "~@less/mixins/mixins.less";

	@phone-padding-top: 19px;
	@phone-padding-right: 30px;
	@phone-padding-bottom: 24px;
	@phone-padding-left: 18px;
	@phone-width: 305px;
	@phone-height: 500px;

	.phone {
		// background: url("~@img/misc/phone.png");
		// -webkit-background-size: cover;
		// background-size: cover;

		width: @phone-width;
		height: @phone-height;
		padding-top: @phone-padding-top;
		padding-right: @phone-padding-right;
		padding-bottom: @phone-padding-bottom;
		padding-left: @phone-padding-left;

		-webkit-transition: all 200ms ease-in-out;
		-moz-transition: all 200ms ease-in-out;
		-ms-transition: all 200ms ease-in-out;
		-o-transition: all 200ms ease-in-out;
		transition: all 200ms ease-in-out;

		&.side-right {
		}
	}

	.phone-screen {
		width: 100%;
		height: 100%;
		border: 10px solid #111;
		border-radius: 25px;
		overflow: hidden;
		padding: 10px;

		.media-container {
			margin: 0px;
			max-width: 100%;
		}
	}

	.media-lg({
		.phone {
			width: @phone-width * @size-percentage-lg;
			height: @phone-height * @size-percentage-lg;

			padding-top: @phone-padding-top * @size-percentage-lg;
			padding-right: @phone-padding-right * @size-percentage-lg;
			padding-bottom: @phone-padding-bottom * @size-percentage-lg;
			padding-left: @phone-padding-left * @size-percentage-lg;
		}
	});

	.media-xl({
		.phone {
			width: @phone-width * @size-percentage-xl;
			height: @phone-height * @size-percentage-xl;

			padding-top: @phone-padding-top * @size-percentage-xl;
			padding-right: @phone-padding-right * @size-percentage-xl;
			padding-bottom: @phone-padding-bottom * @size-percentage-xl;
			padding-left: @phone-padding-left * @size-percentage-xl;
		}
	});

	.media-xxl({
		.phone {
			width: @phone-width * @size-percentage-xxl;
			height: @phone-height * @size-percentage-xxl;

			padding-top: @phone-padding-top * @size-percentage-xxl;
			padding-right: @phone-padding-right * @size-percentage-xxl;
			padding-bottom: @phone-padding-bottom * @size-percentage-xxl;
			padding-left: @phone-padding-left * @size-percentage-xxl;
		}
	});
</style>